import axios from "axios";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
// import Swiper from "swiper";
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import "./index.scss";
import loader from "../../images/loader.svg";
import locationIcon from "../../images/locationIcon.svg"; // https://freeicons.io/
import Loader from "../shared/site/Loader";
import loaderStatic from "../../images/loaderStatic.svg";
import switch_on from "../../images/listView.svg";
import switch_off from "../../images/gridView.svg";

const EarthQuakeFeed = () => {
  const [result, setResult] = useState(null);
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listView, setListView] = useState(false);
  const [timezone, setTimezone] = useState(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const swiperRef = useRef(null);
  const swiperSmallRef = useRef(null);
  const hourlyMag =
    "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_hour.geojson";
  const smallMag =
    "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_day.geojson";
  const signifigantMag =
    "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/significant_day.geojson";
  const magFourPlus =
    "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_day.geojson";
  const [jsonEndpoint, setJsonEndpoint] = useState(hourlyMag);

  const [openDetails, setOpenDetails] = useState(false);
  // const [AllDayLoading, setAllDayLoading] = useState(false);
  // const [AllDayResult, setAllDayResult] = useState(null);
  // const [AllDayData, setAllDayData] = useState(false);
  // const swiperAllDayRef = useRef(null);
  // const [showAllDay, setShowAllDay] = useState(false);
  // const [checkAll, setCheckDay] = useState(false);
  // https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_day.geojson
  // https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/significant_day.geojson
  // https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_day.geojson
  //https://earthquake.usgs.gov/earthquakes/feed/policy.php
  const getEarthquakeData = async () => {
    setLoading(true);
    let res = await axios(jsonEndpoint);
    setResult(res?.data);
    setLoading(false);
    // console.log(res?.data);
  };

  useEffect(() => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezone);
    getEarthquakeData();
  }, [data]);

  const refresh = () => {
    swiperRef?.current?.swiper?.slideTo(0);
    swiperSmallRef?.current?.swiper?.slideTo(0);
    goToClicked(0);
    setData((prev) => !prev);
  };

  const convertTZ = (date, tzString) => {
    // debugger;
    let newdate = new Date(
      (typeof date === "string" ? new Date(date) : date)?.toLocaleString(
        "en-US",
        { timeZone: tzString }
      )
    );

    var str = newdate.toString();
    // this should be safe since nothing else in the date string contains a opening paren
    var index = str.indexOf(" (");

    // if the index exists
    if (~index) {
      str = str.substr(0, index);
    }

    return str;
  };

  const goToClicked = (index) => {
    if (!!swiperRef?.current?.swiper) {
      swiperRef?.current?.swiper?.slideTo(index);
      setCurrentSlideIndex(index);
    }
  };

  // all day
  // const getAllDayEarthquakeData = async () => {
  //   setAllDayLoading(true);
  //   let res = await axios(
  //     // "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_day.geojson"
  //     "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_day.geojson"
  //   );
  //   setAllDayResult(res?.data);
  //   setAllDayLoading(false);
  //   console.log(res?.data);
  // };

  // useEffect(() => {
  //   const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //   setTimezone(timezone);
  //   getAllDayEarthquakeData();
  // }, [AllDayData]);

  // const refreshAllDay = () => {
  //   // setAllDayData((prev) => !prev);
  //   setCheckDay((prev) => !prev);
  //   refresh();
  // };

  const handleChangeType = (e) => {
    if (e.target.value === "0") {
      setJsonEndpoint(hourlyMag);
    }
    if (e.target.value === "1") {
      setJsonEndpoint(signifigantMag);
    }
    if (e.target.value === "2") {
      setJsonEndpoint(magFourPlus);
    }
    if (e.target.value === "3") {
      setJsonEndpoint(smallMag);
    }
  };

  useEffect(() => {
    refresh();
  }, [jsonEndpoint]);

  return (
    <div className={clsx("feedback-earthquake", openDetails ? "show" : "")}>
      <div className="comp-wrap">
        <div className="feedback-earthquake-reference">
          <div className="comp-cont">
            <div className="feedback-text flex-it flex-align-item-center flex-wrap">
              <div className="buttons-wrap">
                <div className="auto">
                  <select onChange={(e) => handleChangeType(e)}>
                    <option value={0}>Hourly Earthquakes</option>
                    <option value={1}>Significant Earthquakes</option>
                    <option value={2}>Magnitude 4.5+ Earthquakes</option>
                    <option value={3}>Magnitude 2.5+ Earthquakes</option>
                  </select>
                  {result?.features?.length > 0 ? (
                    <div className="number-earthquakes flex-it flex-align-item-center">
                      ({result?.features?.length})
                    </div>
                  ) : null}
                  <div
                    className="checkout-btn refresh-btn"
                    onClick={() => refresh()}
                  >
                    {loading ? (
                      <img src={loader} alt={`loader`} />
                    ) : (
                      <img src={loaderStatic} alt={`loader`} />
                    )}
                  </div>

                  <div
                    className="checkout-btn list-icon-swap"
                    onClick={() => setListView((prev) => !prev)}
                  >
                    <img
                      src={listView ? switch_on : switch_off}
                      alt={"switch"}
                    />
                  </div>
                </div>
                {/* <div className="nb-of-earthquakes">
                  {result?.features?.length > 0
                    ? `(${result?.features?.length} Earthquake${
                        result?.features?.length > 1 ? "s" : ""
                      })`
                    : ""}{" "}
                </div> */}
              </div>
            </div>
          </div>

          <div className="comp-wrap">
            <div className="comp-cont">
              <div
                onClick={() => setOpenDetails((prev) => !prev)}
                className="more-items checkout-btn refresh-btn flex-it flex-align-item-center flex-justify-center"
              >
                <div className="text-more-less">
                  {openDetails ? "Less" : "More"}
                </div>
              </div>

              <div
                className={clsx(
                  "small-items-list",
                  !!listView ? "list-view" : "swiper-view"
                )}
              >
                {!listView && (
                  <div
                    className={clsx(
                      "magnitude-only magnitude-colors flex-it flex-wrap"
                    )}
                  >
                    <Swiper
                      ref={swiperSmallRef}
                      spaceBetween={4}
                      slidesPerView={"auto"}
                    >
                      {result?.features?.length > 0 ? (
                        result?.features?.map((item, index) => {
                          return (
                            <SwiperSlide
                              key={index}
                              className={clsx(
                                index === currentSlideIndex
                                  ? "custom-active"
                                  : ""
                              )}
                            >
                              <div
                                onClick={() => goToClicked(index)}
                                key={index}
                                className={clsx(
                                  index === currentSlideIndex
                                    ? "custom-active"
                                    : "",
                                  "magnitude-item flex-it flex-align-item-center flex-justify-center",
                                  `magnitude-${Math.floor(
                                    item?.properties?.mag
                                  )}`,
                                  item?.properties?.mag < 0
                                    ? "magnitude-under-zero"
                                    : ""
                                )}
                              >
                                {item?.properties?.mag}
                                <br />
                                {item?.properties?.place?.indexOf(",") !== -1
                                  ? item?.properties?.place?.split(",")?.[1]
                                  : item?.properties?.place}
                              </div>
                            </SwiperSlide>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </Swiper>

                    {result?.features?.length <= 0 ? (
                      <div className="no-data">No Data</div>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
                {listView && (
                  <div
                    className={clsx(
                      "magnitude-only magnitude-colors  flex-it flex-wrap"
                    )}
                  >
                    {result?.features?.length > 0 ? (
                      result?.features?.map((item, index) => {
                        return (
                          <div
                            onClick={() => goToClicked(index)}
                            key={index}
                            className={clsx(
                              index === currentSlideIndex
                                ? "custom-active"
                                : "",
                              "magnitude-item flex-it flex-align-item-center flex-justify-center",
                              `magnitude-${Math.floor(item?.properties?.mag)}`,
                              item?.properties?.mag < 0
                                ? "magnitude-under-zero"
                                : ""
                            )}
                          >
                            {item?.properties?.mag}
                            <br />
                            {item?.properties?.place?.indexOf(",") !== -1
                              ? item?.properties?.place?.split(",")?.[1]
                              : item?.properties?.place}
                          </div>
                        );
                      })
                    ) : (
                      <div className="no-data">No Data</div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrap-swiper-loader">
        <Swiper
          ref={swiperRef}
          spaceBetween={10}
          slidesPerView={4}
          breakpoints={{
            0: {
              slidesPerView: 1.2,
            },
            500: {
              slidesPerView: 2,
            },
            890: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
        >
          {result?.features?.length > 0 &&
            result?.features
              ?.filter((item) => item?.properties?.type === "earthquake")
              .map((item, index) => {
                // debugger;

                let mapID =
                  item?.properties?.ids?.indexOf(",") !== -1
                    ? item?.properties?.ids?.split(",")?.[1]
                    : item?.properties?.ids;

                return (
                  <SwiperSlide
                    key={index}
                    className={clsx(
                      index === currentSlideIndex ? "custom-active" : ""
                    )}
                  >
                    <div
                      className={clsx(
                        "feedback-earthquake-properties ",
                        `magnitude-${Math.floor(item?.properties?.mag)}`,
                        item?.properties?.mag < 0 ? "magnitude-under-zero" : ""
                      )}
                    >
                      <div className="earthquake-magnitude">
                        {/* <div className="earthquake-circle"></div> */}

                        <div className="earthquake-place-date">
                          <div className="data-auto">
                            <div className="earthquake-mag flex-it flex-align-item-center flex-wrap">
                              Earthquake Magnitude:
                              <span className="mag-number">
                                {item?.properties?.mag}
                              </span>
                              <div className="earthquake-circle"></div>
                            </div>
                            <div className="earthquake-palce">
                              Location: {item?.properties?.place}
                            </div>
                            <div className="earthquake-date">
                              {convertTZ(
                                new Date(item?.properties?.time)?.toUTCString(),
                                timezone
                              )}
                            </div>
                          </div>
                          <a
                            rel="noreferrer"
                            className="checkout-btn map-view check-location flex-nowrap flex-align-item-center"
                            target={"_blank"}
                            href={`https://earthquake.usgs.gov/earthquakes/eventpage/${mapID}/map`}
                          >
                            <div className="auto flex-it flex-nowrap flex-align-item-center">
                              <div className="auto-wrap">
                                <div className="text">Map</div>
                                <img src={locationIcon} alt={`location Icon`} />
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
        </Swiper>
        {loading && <Loader />}
      </div>
    </div>
  );
};

export default EarthQuakeFeed;
